import partition from './../utility/partition'

const formData = form => {
	return [].reduce.call(form.elements || [], (data, element) => {	
		if (!element.name) return data;
		if (element.type === 'checkbox')  {
			const existing = (data[element.name] !== undefined || Array.isArray(data[element.name]))
			if (!existing) data[element.name] = []
			if (element.checked) data[element.name].push(element.value)
		} else if (element.type === 'radio') {
			if (element.checked) data[element.name] = element.value
		} else {
			data[element.name] = element.value;
		}
		return data;
	}, {});
}


export default function init() {

	const items = [...document.querySelectorAll('.js-events-filter-items')]
	const form = document.querySelector('.js-events-filter-desktop')
	const formMobile = document.querySelector('.js-events-filter-mobile')

	if (!form || !formMobile) return;

	const statusEl = document.querySelector('.js-events-status--desktop')
	;[form, formMobile].map(x => x.addEventListener('submit', e => e.preventDefault()))

	
	// match form values in mobile and desktop forms 
		
		const inputChange = event => {
			const { name, value, type, checked } = event.currentTarget

			const els = [
				...form.querySelectorAll(`input[name=${name}]`), 
				...formMobile.querySelectorAll(`input[name=${name}]`)
			]

			const [checkboxesAndRadios, fields] = partition(els, el => el.type === 'checkbox' || el.type === 'radio')
			checkboxesAndRadios.filter(el => el.value === value).forEach(el => el.checked = checked)
			fields.forEach(el => el.value = value)

			run()
		}

		const selectChange = event => {
			const { name, value, type } = event.currentTarget

			const els = [
				...form.querySelectorAll(`select[name=${name}]`), 
				...formMobile.querySelectorAll(`select[name=${name}]`)
			]

			els.map(el => el.value = value)

			run()
		}

	// render funcs

		const sort = (asc = true) => {
			return (a, b) => {
				if (a.getAttribute('data-date') === b.getAttribute('data-date')) return 0
				const order = (a.getAttribute('data-date') > b.getAttribute('data-date')) ? 1 : -1
				return asc ? order : -order;
			}
		}

		const show = ({ events, location }) => {

			const currentDate = new Date().toISOString()
			let showCount = 0;

			const sortMap = {
				'all' : sort(false),
				'past' : sort(false),
				'upcoming' : sort(true),
			}
			
			items.sort(sortMap[events] || sort());

			items.map(item => {

				// sort to work
				item.parentNode.appendChild(item)

				const date = item.getAttribute('data-date')
				const itemLocation = item.getAttribute('data-location')
				const past = (currentDate > date)
				const future = (currentDate <= date)

				const locationMatch = 
					// match all
					!location || 
					// match specific
					(location.trim().toLowerCase() === itemLocation.trim().toLowerCase())

				const eventsMatch = 
					(events === 'all') || 
					(events === 'past' && past) ||
					(events === 'upcoming' && future)

				const matched = (eventsMatch && locationMatch)
				if (matched) showCount++
				item.style.display = matched ? 'block' : 'none';
			})

			return showCount
		}

		const status = (count, { events, location }) => {

			const eventString = count === 1 ? 'event' : 'events'
			const type = (() => {
				if (events === 'upcoming') return 'upcoming'
				if (events === 'past') return 'past'
				if (events === 'all') return ""
			})()

			const locationString = location && `in <span class="text-highlight">${location}</span>` || ''

			if (!count) return `<p>No ${type} events found ${locationString}</p>`

			return `
				<p>Showing ${count > 1 && !type && 'all' || ''} <strong>${count}</strong> ${type} ${eventString} ${locationString}</p>
			`
		}

	// events and run

	const data = formData(form)

		const run = () => {
			const data = formData(form)
			console.log(data)
			const number = show(data)
			statusEl.innerHTML = status(number, data)
		}

		run()

		// run when back button is used
		window.addEventListener('pageshow', run);

		;[form, formMobile].map(form => {
			const inputs = [...form.querySelectorAll('input[type=radio], input[type=checkbox]')]
			const selects = [...form.querySelectorAll('select')]
			selects.map(select => select.addEventListener('change', selectChange))
			inputs.map(input => input.addEventListener('change', inputChange))
		})
}